import { combineReducers } from 'redux-immutable';

import ReferencesReducer from './ReferencesReducer/ReferencesReducer';
import { BaseReferencesStore } from './ReferencesReducer/ReferencesReducer.types';
import SearchReducer from './SearchReducer/SearchReducer';
import { BaseSearchStore } from './SearchReducer/SearchReducer.types';
import TutorialsReducer from './TutorialsReducer/TutorialsReducer';
import { BaseTutorialsStore } from './TutorialsReducer/TutorialsReducer.types';
import VideoCoursesReducer from './VideoCoursesReducer/VideoCoursesReducer';
import { BaseVideoCoursesStore } from './VideoCoursesReducer/VideoCoursesReducer.types';

export interface BaseLearnStoreElement {
  references: BaseReferencesStore;
  tutorials: BaseTutorialsStore;
  videoCourses: BaseVideoCoursesStore;
  search: BaseSearchStore;
}

export const LearnReducer = combineReducers<BaseLearnStoreElement>({
  references: ReferencesReducer,
  tutorials: TutorialsReducer,
  videoCourses: VideoCoursesReducer,
  search: SearchReducer,
});

export interface BaseLearnStore {
  learn: BaseLearnStoreElement;
}
